/*! @azure/msal-browser v3.27.0 2024-11-05 */
'use strict';

/* eslint-disable header/header */
const name = "@azure/msal-browser";
const version = "3.27.0";
export { name, version };
